import { Component, Output, EventEmitter, Input, OnDestroy } from '@angular/core';

@Component({
  selector: 'xe-lottie',
  templateUrl: 'xe-lottie.html'
})
export class XeLottieComponent implements OnDestroy {
  @Input() options;
  @Input() width;
  @Input() height;
  @Input() autoplay: boolean = false;
  @Output() animCreated = new EventEmitter<any>();
  anim;
  enterTimeout;
  stopped: boolean = false;

  constructor() {
  }

  ngOnChanges() {
    if (this.options)
      this.options.autoplay = this.autoplay;
  }

  ngOnDestroy() {
    if (this.anim) {
      this.anim.destroy();
      this.anim = null;
    }    
  }

  enter() {
    if (this.enterTimeout) {
      window.clearTimeout(this.enterTimeout);
      this.enterTimeout = null;
    }
    if (this.stopped)
      window.requestAnimationFrame(() => {
        this.stopped = false;
      });
    if (this.anim)
      this.anim.play();
    else
      this.enterTimeout = window.setTimeout(() => {
        this.enterTimeout = null;
        this.enter();
      }, 100);
  }

  leave() {
    if (this.enterTimeout) {
      window.clearTimeout(this.enterTimeout);
      this.enterTimeout = null;
    }
    if (this.anim && !this.autoplay) {
      this.anim.stop();
      if (!this.stopped)
        window.requestAnimationFrame(() => {
          this.stopped = true;
        });
    }
  }

  onAnimCreated(ev) {
    this.anim = ev;
    this.animCreated.emit(ev);
  }
}



// WEBPACK FOOTER //
// ./src/components/xe-lottie/xe-lottie.ts